// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDVAk_YBMwBnUZTUFUia3XObLJxHVwALlo",
    authDomain: "curbside-1435d.firebaseapp.com",
    databaseURL: "https://curbside-1435d.firebaseio.com",
    projectId: "curbside-1435d",
    storageBucket: "curbside-1435d.appspot.com",
    messagingSenderId: "853045657510",
    appId: "1:853045657510:web:601998a3bf4d66f05dd967",
    measurementId: "G-7GDGCY3839"
  }
};
